import { AgGridModule } from '@ag-grid-community/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppFormsModule } from '@ideapa/app-forms';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap/collapse';
import { NgbDropdown, NgbDropdownAnchor, NgbDropdownButtonItem, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap/dropdown';
import { NgbPagination, NgbPaginationEllipsis, NgbPaginationFirst, NgbPaginationLast, NgbPaginationNext, NgbPaginationNumber } from '@ng-bootstrap/ng-bootstrap/pagination';
import { NgbHighlight, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap/typeahead';
import { NgSelectModule } from '@ng-select/ng-select';
import { PushPipe } from '@ngrx/component';
import { MomentModule } from 'ngx-moment';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ToastrModule } from 'ngx-toastr';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { CopyFromEnteModalComponent } from './copy-from-ente-modal/copy-from-ente-modal.component';
import { UiKitCoreModule } from './core/uikit-core.module';
import { DuplicateModalComponent } from './duplicate-modal/duplicate-modal.component';
import { EntityListComponent } from './entity-list/entity-list.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { FeatherIconDirective } from './feather-icon/feather-icon.directive';
import { FiltersFormComponent } from './filters/filters-form/filters-form.component';
import { OperatorFilterComponent } from './filters/operators/operators.component';
import { SingleFilterComponent } from './filters/single-filter/single-filter.component';
import { FormFieldsModule } from './form-fields/form-fields.module';
import { CustomGridFilterComponent } from './grid/custom-grid-filter.component';
import { DataGridActionRenderer } from './grid/data-grid/data-grid-action-renderer.component';
import { DataGridComponent } from './grid/data-grid/data-grid.component';
import { ImportModalComponent } from './import-modal/import-modal.component';
import { LoaderComponent } from './loader/loader.component';
import { ToastComponent } from './toast/toast.component';
// import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppFormsModule,
    ReactiveFormsModule,
    AgGridModule,
    NgbPagination, 
    NgbPaginationEllipsis,
     NgbPaginationFirst, 
     NgbPaginationLast, 
     NgbPaginationNext, 
     NgbPaginationNumber,
    NgbHighlight, NgbTypeahead,
    PushPipe,
    NgxPermissionsModule.forChild(),
    UiKitCoreModule,
    NgbDropdown, NgbDropdownAnchor, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, NgbDropdownButtonItem,
    FormFieldsModule,
    BreadcrumbModule,
    NgbCollapse,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      tapToDismiss: true,
      // iconClasses: {
      //   error: 'toast-error',
      //   info: 'toast-info',
      //   success: 'toast-success',
      //   warning: 'toast-warning',
      // },
    }),
    MomentModule,
    NgSelectModule,
  ],
  declarations: [
    FiltersFormComponent,
    SingleFilterComponent,
    OperatorFilterComponent,
    EntityListComponent,
    FeatherIconDirective,
    CustomGridFilterComponent,
    DataGridActionRenderer,
    BreadcrumbComponent,
    LoaderComponent,
    ToastComponent,
    ErrorPageComponent,
    DataGridComponent,
    DuplicateModalComponent,
    ImportModalComponent,
    CopyFromEnteModalComponent,
    ConfirmDialogComponent,
  ],
  exports: [
    ErrorPageComponent,
    FiltersFormComponent,
    EntityListComponent,
    FeatherIconDirective,
    UiKitCoreModule,
    CustomGridFilterComponent,
    FormFieldsModule,
    BreadcrumbComponent,
    LoaderComponent,
    DataGridComponent,
    MomentModule,
    SingleFilterComponent,
    DuplicateModalComponent,
    ImportModalComponent,
    CopyFromEnteModalComponent,
  ],
  // schemas: [NO_ERRORS_SCHEMA],
})
export class AppUiKitModule {}
